import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PhosphorWarning } from "components/Atoms/PhosphorIcon";

interface CompanyContactListProps {
  companyId: number;
  excludeKeys?: number[];
  onItemSelected: (item: server.dto.ContactSmallV2) => void;
  onSwitchToSearch: (keyword: string) => void;
}

const CompanyContactList = (props: CompanyContactListProps) => {
  const [hasNoResults, setHasNoResults] = React.useState(false);

  const [instruction, setInstruction] = React.useState<server.dto.ListContactByCompanyInstruction>({
    companyId: props.companyId,
    page: 1,
    perPage: 100,
    keyword: "",
  });

  React.useEffect(() => {
    if (hasNoResults) {
      props.onSwitchToSearch("");
    }
  }, [hasNoResults]);

  const api = React.useCallback((instruction: server.dto.ListContactByCompanyInstruction) => {
    return window.CoreApi.CompanyToContact.ListContactByCompany(instruction)
      .then(r => {
        if (r.data.data.length === 0) {
          setHasNoResults(true);
        }
        return {
          ...r,
          data: {
            ...r.data,
            data: r.data.data.map(item => item.contact),
          },
        };
      });
  }, []);

  const handleInstructionChange = (newInstruction: server.dto.ListContactByCompanyInstruction) => {
    if (newInstruction.keyword) {
      props.onSwitchToSearch(newInstruction.keyword);
      return;
    }
    setInstruction(newInstruction);
  };

  return <PickerList
    instruction={instruction}
    onInstructionChange={handleInstructionChange}
    queryKey="companycontactpickerlist"
    api={api}
    onClick={props.onItemSelected}
    getError={() => undefined}
    excludeKeys={props.excludeKeys}
    getId={contact => contact.contactId}
    renderListItem={contact => <div className="flex">
      <div className="grow1">
        <div>{contact.name.fullName}</div>
        <SubLabel>{contact.position}</SubLabel>
      </div>

      {!contact.isValidated && (
        <div>
          <PhosphorWarning iconSize="large" />
        </div>)}
    </div>}
  />
};

export default CompanyContactList;
